// extracted by mini-css-extract-plugin
export default {"theme":"light_theme__TTz0Q"};